export enum CURRENCY {
    RUB = "RUB",
    USD = "USD",
}
